// src/pages/Fi gurines.js
export default function Figurines() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>Figurines</h1>
     <p style={{ fontSize: "1.2rem", lineHeight: "1.6", maxWidth: "800px", margin: "0 auto" }}>
       Les personnages qui pilotent ces machines fantastiques sont des pièces uniques. <br />
       Elles sont dessinées en 3 dimensions sur l'ordinateur puis imprimées sur une imprimante 3D. <br /> 
      Au final, elles sont peintes à la main.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "20px",
          marginTop: "2rem",
        }}
      >
        <div>
          <img
            src="/images/figurines/figurine1.jpg"
            alt="Figurine 1"
            style={{ width: "100%", height: "auto", borderRadius: "10px" }}
          />
          <p>Figurines</p>
        </div>
        <div>
          <img
            src="/images/figurines/figurine2.jpg"
            alt="Figurine 2"
            style={{ width: "100%", height: "auto", borderRadius: "10px" }}
          />
          <p>Dessin 3D</p>
        </div>
        <div>
          <img
            src="/images/figurines/figurine3.jpg"
            alt="Figurine 3"
            style={{ width: "100%", height: "auto", borderRadius: "10px" }}
          />
          <p>Impression 3D</p>
        </div>
        <div>
          <img
            src="/images/figurines/figurine4.jpg"
            alt="Figurine 4"
            style={{ width: "100%", height: "auto", borderRadius: "10px" }}
          />
          <p>Peinture</p>
        </div>
      </div>
    </div>
  );
}
